import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var EarthSvg = function EarthSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2 12.249c0-5.522 4.478-10 10-10s10 4.478 10 10-4.478 10-10 10-10-4.478-10-10m10-8.636a8.637 8.637 0 0 0-8.104 11.629H7V9.54h5.454V3.624A9 9 0 0 0 12 3.613m1.818.191v7.1H8.364v5.701H4.542A8.63 8.63 0 0 0 12 20.886c.93 0 1.827-.147 2.667-.42v-.075l-1.77-2.809v-3.99h7.636q.102-.657.103-1.342c0-4.145-2.922-7.61-6.818-8.445m6.386 11.15a8.66 8.66 0 0 1-4.224 4.961l-1.719-2.727v-2.233z",
    clipRule: "evenodd"
  }));
};
export var Earth = function Earth(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: EarthSvg
  }));
};